import { Controller } from '@hotwired/stimulus'

/**
 * Design Tabs Controller
 *
 * Manages tab switching for the design phase content panels
 * (Services, Locations, Generation)
 */
export default class extends Controller {
  static targets = ['tab', 'panel']

  static values = {
    activeTab: { type: String, default: 'services' }
  }

  connect() {
    // Check URL hash for tab selection
    const hash = window.location.hash.replace('#', '')
    if (hash && ['services', 'locations', 'generation'].includes(hash)) {
      this.activeTabValue = hash
    }

    this.showTab(this.activeTabValue)
  }

  selectTab(event) {
    event.preventDefault()
    const tab = event.currentTarget.dataset.tab
    this.activeTabValue = tab
    this.showTab(tab)

    // Update URL hash without scrolling
    history.replaceState(null, null, `#${tab}`)
  }

  showTab(tabName) {
    // Update tab styles
    this.tabTargets.forEach((tab) => {
      const isActive = tab.dataset.tab === tabName
      if (isActive) {
        tab.classList.add('border-primary-600', 'text-primary-600')
        tab.classList.remove('border-transparent', 'text-gray-500')
      } else {
        tab.classList.remove('border-primary-600', 'text-primary-600')
        tab.classList.add('border-transparent', 'text-gray-500')
      }
    })

    // Show/hide panels
    this.panelTargets.forEach((panel) => {
      const isActive = panel.dataset.panel === tabName
      panel.classList.toggle('hidden', !isActive)
    })
  }
}
